import React from 'react'
import Loader from '../loader'

export const UploadInProgress = () => {
  return <div className="restaurant-pool-schedule upload-in-progress">
    <div className="row">
      <div className="col-md-6">
        <h5>Creating schedules... this could take up to 30 seconds</h5>
      </div>
    </div>
    <div className="row">
      <div className="col-md-6">
        <Loader/>
      </div>
    </div>
  </div>
}


// WEBPACK FOOTER //
// ./src/components/restaurantPoolSchedule/uploadInProgress.js